export default {
  meta: {
    title: '即插即踩'
  },
};
